import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { DeduccionesIIGG } from '../../../../models/deducciones-IIGG';
import { DeduccionesIiggService } from '../../../../services/deducciones-iigg.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-deduciones-iigg-list',
  templateUrl: './deduciones-iigg-list.component.html',
  styleUrls: ['./deduciones-iigg-list.component.css']
})
export class DeducionesIiggListComponent implements OnInit {

  @Input() personalId: number;
  @Input() deducciones: DeduccionesIIGG[];
  @Input() permisoEdicion: boolean = true;
  @Output() VisualizarDetalle = new EventEmitter<DeduccionesIIGG>();
    
  deduccionesOri: DeduccionesIIGG[];
  deduccionesGrupo: DeduccionesIIGG[];
  filtroDesde: string;
  filtroHasta: string;
  agrupar: boolean = false;

  constructor(private deduccionesService: DeduccionesIiggService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.deduccionesOri = this.deducciones;
    this.inicializaFiltros();
    
    this.filtrarDeducciones();
  }

  inicializaFiltros()
  {
    let fechaHoy = new Date();
    let fechaIni = new Date();
    fechaIni.setDate(fechaIni.getDate() - 30);

    let mesString = ('0' + (fechaIni.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    let diaString = ('0' + (fechaIni.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroDesde = (fechaIni.getFullYear()).toString() + "-" + mesString + "-" + diaString ;

    mesString = ('0' + (fechaHoy.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    diaString = ('0' + (fechaHoy.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroHasta = (fechaHoy.getFullYear()).toString() + "-" + mesString + "-" + diaString ;
  }

  filtrarDeducciones()
  {
    let desde = moment(this.filtroDesde, "YYYY/MM/DD").toDate();
    let hasta = moment(this.filtroHasta, "YYYY/MM/DD").toDate();
    
    this.deducciones = this.deduccionesOri.filter(i => Date.parse(i.desde) <= hasta.getTime() && Date.parse(i.hasta) >= desde.getTime());    
  }

  onChangeAgrupamiento()
  {
    //Cambia lista
    if (this.agrupar == true)
    {
      if (this.deduccionesGrupo == undefined)
      {
        this.deduccionesService.getByPersonal(this.personalId, true).subscribe(
          data =>
          {
            data.forEach((currentValue,index,arr) => {
              currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
              currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
            });
            
            this.deduccionesGrupo = data;
            this.deducciones = this.deduccionesGrupo;
          });

      } else
      {
        this.deducciones = this.deduccionesGrupo;
      }
      
    } else
    {
      this.filtrarDeducciones();
    }
  }

  onChangeFiltros()
  {
    this.filtrarDeducciones();
  }

  visualizarDetalle(dedu)
  {
    this.VisualizarDetalle.emit(dedu);
  }

  add()
  {
    let deduccion: DeduccionesIIGG = { id: 0, personal: this.personalId, desde: new Date().toString(), hasta: new Date("2999-12-31T23:59:59").toString(), cantidad: 0, importe: 0, moneda: 1, personaJuridica: "", claseDocumento: 0, docNro: '' };
    this.VisualizarDetalle.emit(deduccion);
  }
}
